import { isProductionMode } from "./consts"

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`
  const parts = value.split(`; ${name}=`)

  if (parts && parts.length === 2) return parts.pop()?.split(";").shift()
}

export const getAuthCookie = (): string | undefined => {
  if (isProductionMode()) {
    return getCookie("prodToken")
  }

  // For staging and local development, use stagingToken
  return getCookie("stagingToken")
}
